import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

function capitalizeFirstLetter(palavra) {
  return palavra.charAt(0).toUpperCase() + palavra.slice(1);
}

const DuplicatedAlert = ({
  handleDuplicateIn,
  open,
  dtRegister,
  companies,
  handleDuplicateOut,
  disabled,
}) => (
  <>
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <DialogTitle style={{ paddingRight: 10 }} >{companies && capitalizeFirstLetter(companies.lastTypeText)} duplicada </DialogTitle> <ErrorOutlineIcon fontSize="26px" color="error" />
      </div>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          O seu ponto anterior também foi uma {companies && companies.lastTypeText}, <strong>dia {' '}
            {dtRegister && dtRegister.format('DD/MM/YYYY')} às {' '}
            {dtRegister && dtRegister.format('HH:mm')}
                                                                                     </strong> Gostaria
          de alterar o ponto atual ? 
          {/* para uma {companies && companies.nextTypeText}? */}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDuplicateIn} color="primary" disabled={disabled}>
          ENTRADA
        </Button>
        <Button onClick={handleDuplicateOut} disabled={disabled} color="primary" variant="contained" autoFocus>
          SAIDA
        </Button>
      </DialogActions>
    </Dialog>
  </>
);

DuplicatedAlert.propTypes = {
  handleDuplicateIn: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  dtRegister: PropTypes.string.isRequired,
  companies: PropTypes.object.isRequired,
  handleDuplicateOut: PropTypes.func.isRequired,
};

export default DuplicatedAlert;
